module.exports = __webpack_public_path__ + "preloader.full.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/preloader/preloader.full.png
// module id = 1248
// module chunks = 8